<!--crud company-->
<script> 
    import { Table, Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Input, Container, Row, Card, CardBody } from 'sveltestrap';
    import { fade } from 'svelte/transition';
    import Swal from 'sweetalert2';
  
    let items = [
      { nombre_compania: "Compañía A", direccion: "Calle Falsa 123", representante: "Juan Perez", email: "juan@example.com", telefono_contacto: "123456789", created: new Date() },
      { nombre_compania: "Compañía B", direccion: "Av. Siempre Viva 742", representante: "Luis Gomez", email: "luis@example.com", telefono_contacto: "987654321", created: new Date() },
      { nombre_compania: "Compañía C", direccion: "Calle Inventada 456", representante: "Maria Martinez", email: "maria@example.com", telefono_contacto: "564738291", created: new Date() },
      { nombre_compania: "Compañía D", direccion: "Avenida Principal 789", representante: "Jose Rodriguez", email: "jose@example.com", telefono_contacto: "1122334455", created: new Date() }
    ];
  
    let showModal = false;
    let selectedItem = null;
    let mode = 'add';
    let formData = {};
  
    const openAddModal = () => {
      mode = 'add';
      formData = {};
      showModal = true;
    };
  
    const openEditModal = (item) => {
      mode = 'edit';
      selectedItem = item;
      formData = { ...item };
      showModal = true;
    };
  
    const saveItem = () => {
      if (mode === 'add') {
        const newItem = {
          ...formData,
          id: Math.max(...items.map(i => i.id), 0) + 1,
          created: new Date(),
        };
        items = [...items, newItem];
      } else {
        items = items.map(item => item.email === selectedItem.email ? { ...item, ...formData } : item);
      }
      showModal = false;
    };
  
    const deleteItem = (email) => {
      Swal.fire({
        title: '¿Estás seguro?',
        text: '¡No podrás revertir esto!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminarlo!'
      }).then((result) => {
        if (result.isConfirmed) {
          items = items.filter(item => item.email !== email);
          Swal.fire('Eliminado!', 'El registro ha sido eliminado.', 'success');
        }
      });
    };
  </script>
  
  <div class="page-content">
    <Container fluid>
      <div class="breadcrumb-title">
        <h4>COMPAÑIA</h4>
      </div>
      <Row>
        <div class="col-12">
          <Card>
            <CardBody>
              <div class="table-responsive">
                <Table class="align-middle table-nowrap table">
                  <thead class="table-light">
                    <tr>
                      <th>Nombre Compañía</th>
                      <th>Dirección</th>
                      <th>Representante</th>
                      <th>Email</th>
                      <th>Teléfono de Contacto</th>
                      <th>Fecha Creación</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {#each items as item (item.email)}
                      <tr transition:fade>
                        <td>{item.nombre_compania}</td>
                        <td>{item.direccion}</td>
                        <td>{item.representante}</td>
                        <td>{item.email}</td>
                        <td>{item.telefono_contacto}</td>
                        <td>{item.created.toLocaleDateString()}</td>
                        <td>
                          <Button color="link" on:click={() => openEditModal(item)}>
                            <i class="bx bx-pencil"></i>
                          </Button>
                          <Button color="link" on:click={() => deleteItem(item.email)}>
                            <i class="bx bx-trash text-danger"></i>
                          </Button>
                        </td>
                      </tr>
                    {/each}
                  </tbody>
                </Table>
              </div>
              <ul class="pagination pagination-rounded justify-content-end mb-2">
                <li class="page-item disabled">
                  <a class="page-link" href="/" aria-label="Previous">
                    <i class="mdi mdi-chevron-left" />
                  </a>
                </li>
                <li class="page-item active">
                  <a class="page-link" href="/">1</a>
                </li>
                <li class="page-item"><a class="page-link" href="/">2</a></li>
                <li class="page-item"><a class="page-link" href="/">3</a></li>
                <li class="page-item"><a class="page-link" href="/">4</a></li>
                <li class="page-item"><a class="page-link" href="/">5</a></li>
                <li class="page-item">
                  <a class="page-link" href="/" aria-label="Next">
                    <i class="mdi mdi-chevron-right" />
                  </a>
                </li>
              </ul>
            </CardBody>
          </Card>
        </div>
      </Row>
    </Container>
  
    <Button color="success" class="floating-button" on:click={openAddModal}>Agregar Nuevo</Button>
  
    <Modal isOpen={showModal} toggle={() => showModal = !showModal}>
      <ModalHeader toggle={() => showModal = !showModal}>
        {mode === 'add' ? 'Nuevo Registro' : 'Editar Registro'}
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <label>Nombre Compañía</label>
            <Input bind:value={formData.nombre_compania} required />
          </FormGroup>
          <FormGroup>
            <label>Dirección</label>
            <Input bind:value={formData.direccion} required />
          </FormGroup>
          <FormGroup>
            <label>Representante</label>
            <Input bind:value={formData.representante} required />
          </FormGroup>
          <FormGroup>
            <label>Email</label>
            <Input type="email" bind:value={formData.email} required pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$" />
          </FormGroup>
          <FormGroup>
            <label>Teléfono de Contacto</label>
            <Input bind:value={formData.telefono_contacto} required />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" on:click={() => showModal = false}>Cancelar</Button>
        <Button color="primary" on:click={saveItem}>Guardar</Button>
      </ModalFooter>
    </Modal>
  </div>
  <style>
    .bx {
      font-size: 1.25rem;
      vertical-align: middle;
    }
    .table th {
      background-color: #f8f9fa;
    }
    .floating-button {
      position: fixed;
      bottom: 40px;
      left: 50%;
      transform: translateX(-50%);
      border-radius: 25px;
      padding: 10px 20px;
      font-size: 18px;
      box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
      background-color: #28a745;
      color: white;
    }
  </style>